import axios from '@/libs/axios'

/**
 * Registry of platform feature modules (for sidebar menu groups).
 */
export default {
  namespaced: true,

  state: {
    modules: [],
    loaded: false,
  },

    getters: {
    modules(state) {
      return state.modules
    },
    loaded(state) {
      return state.loaded
    },
    hasModule: (state) => (prefix) => {
      const key = String(prefix || '')
      if (!key) return false
      return (state.modules || []).some(
        (mod) => String(mod.prefix) === key && Number(mod.active) === 1,
      )
    },
    /**
     * Sidebar groups derived from modules.name + modules.navigation.
     */
    navGroups(state) {
      return (state.modules || [])
        .filter((mod) => Number(mod.active) === 1 && Array.isArray(mod.navigation) && mod.navigation.length)
        .map((mod) => {
          const children = [...mod.navigation]
            .sort((a, b) => Number(a.ordering ?? 0) - Number(b.ordering ?? 0))
            .map((item) => {
              const segment = String(item.route || '')
                .replace(/^\/+/, '')
                .replace(/^admin\//, '')
                .replace(new RegExp(`^${mod.prefix}/`), '')

              return {
                title: item.name,
                icon: item.icon || 'CircleIcon',
                // Named route: {prefix}-{segment} e.g. crtcreator-channels
                route: `${mod.prefix}-${segment}`,
                action: 'manage',
                resource: 'Supervisor',
              }
            })

          return {
            title: mod.name,
            icon: 'BoxIcon',
            action: 'manage',
            resource: 'Supervisor',
            children,
          }
        })
    },
  },

  mutations: {
    SET_MODULES(state, value) {
      state.modules = value || []
      state.loaded = true
    },
    CLEAR_MODULES(state) {
      state.modules = []
      state.loaded = false
    },
  },

  actions: {
    loadModules({ commit }) {
      return axios.get('api/modules').then((response) => {
        commit('SET_MODULES', response.data?.data ?? response.data ?? [])
      }).catch((error) => {
        commit('SET_MODULES', [])
        throw error
      })
    },
  },
}
